import React, { useRef, useState } from 'react';
import CustomMessagesTab from '../custom-messages/CustomMessagesTab';
import TableComponent from 'component/molecules/Table/TableComponent';
import * as tableHeader from './factory/keywordHeader';
import { keywordsEndpoints } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';
import AddKeyword from 'component/organism/sensitive-keywords/AddKeyword';

const KeywordTab = ({ refetch, mode, setRefetch }) => {
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState(null);

  const handleEdit = (item) => {
    setItem(item);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setItem(null);
  };

  const filterButtons = [
    {
      type: 'plus',
      label: 'New Keyword',
      func: () => setIsOpen(true),
    },
  ];
  return (
    <div>
      <TableComponent
        headerData={tableHeader.headerData}
        rowKey="id"
        api={{
          get: {
            url: keywordsEndpoints.get,
            queryKey: 'botKeyword',
            params: { botId: id },
          },
          delete: {
            url: keywordsEndpoints?.delete,
          },
        }}
        filterButtons={filterButtons}
        actions={{
          hasEdit: {
            func: handleEdit,
          },
        }}
        isRefetch={refetch}
      />
      <AddKeyword
        isOpen={isOpen}
        onClose={handleClose}
        id={id}
        item={item}
        mode={mode}
        setRefetch={setRefetch}
        refetch={refetch}
      />
    </div>
  );
};

export default KeywordTab;
